import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=75581f89&"
import script from "./FormBuilder.vue?vue&type=script&lang=js&"
export * from "./FormBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputField: require('/vercel/path0/components/forms/InputField.vue').default,Textarea: require('/vercel/path0/components/forms/Textarea.vue').default,Select: require('/vercel/path0/components/forms/Select.vue').default,Checkbox: require('/vercel/path0/components/forms/Checkbox.vue').default,RadioButtons: require('/vercel/path0/components/forms/RadioButtons.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
